export function parsePrismicUrl(data?: string, isProduction?: boolean) {
    const prismicReplacementDomain = !isProduction ?
        'https://cdn.dev.healthlabs.dev' :
        'https://cdn.healthlabs.care';

    const regex = /https:\/\/(?:images\.prismic\.io|healthlabs\.cdn\.prismic\.io|prismic-io\.s3\.amazonaws\.com)/g;
    return data?.replace(regex, prismicReplacementDomain) || '';
}
